import clsx from "clsx";
import React, { useCallback, useRef, useState } from "react";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import { ProductOverlay } from "web/react/components/product-overlay";
import { StorefrontInfoModal } from "web/react/components/storefront-info-modal";
import { container } from "web/react/emo/utilities.css";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { ProductLayoutSerializer, ProductPageAreaSerializer } from "web/types/serializers";
import { Breadcrumbs } from "./breadcrumbs/breadcrumbs";
import { Footer } from "./footer/footer";
import {
    InStockProductPageContextProvider,
    ProductPurchaseType,
} from "./in-stock-product-page.context";
import { wrapper } from "./in-stock-product-page.css";
import { ProductArea } from "./product-area/product-area";
import { ProductPriceComparison } from "./product-price-comparison/product-price-comparison";
import { RelatedArea } from "./suggested-product/suggested-product";

export interface InStockAffiliateProductPageProps {
    productArea: ProductPageAreaSerializer;
    productLayout: ProductLayoutSerializer;
    helpCentreURLs?: string[];
    isOverlay?: boolean;
    parentRef?: React.RefObject<HTMLElement>;
}

export function InStockProductPage({
    productArea,
    productLayout,
    helpCentreURLs,
    isOverlay = false,
    parentRef,
}: InStockAffiliateProductPageProps): JSX.Element {
    const overlayRef = useRef(null);

    const [isModalOpen, setModalOpen] = useState(false);
    // const [isPromoModalOpen, setPromoModalOpen] = useState(false);

    const closeStorefrontInfoModal = useCallback(() => {
        setModalOpen(false);
    }, []);

    const openStorefrontInfoModal = useCallback(() => {
        setModalOpen(true);
    }, []);

    // const openPromoModal = useCallback(() => {
    //     closeStorefrontInfoModal();
    //     setPromoModalOpen(true);
    // }, [closeStorefrontInfoModal]);

    // const closePromoModal = useCallback(() => {
    //     setPromoModalOpen(false);
    // }, []); {/* TODO BEAM-1018 */}

    return (
        <InStockProductPageContextProvider
            initialData={{
                productArea,
                productLayout,
                isOverlay,
                parentRef,
                openRetailerInfoModal: openStorefrontInfoModal,
            }}
        >
            <StorefrontInfoModal
                title={gettext("storefront.modal.title.seller_details")}
                isOpen={isModalOpen}
                onClose={closeStorefrontInfoModal}
                storeFrontURL="https://www.lyst.com/store/wanan-luxury-store/"
            >
                {/* TODO BEAM-1018 */}
                {/* <StorefrontHeaderSummary
                    retailerName={"New Balance"}
                    description={
                        "lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsumlorem ipsum lorem ipsum"
                    }
                    isCheckout={true}
                    isOfficialStore={true}
                    profile={mockProfile}
                    promotions={mockPromotions}
                    onClick={openPromoModal}
                /> */}
                <div>{/* TODO BEAM-1018 remove when real data available */}</div>
            </StorefrontInfoModal>
            {!isOverlay && <CustomerCaptureOverlay />}
            {!isOverlay && (
                <div ref={overlayRef}>
                    <ProductOverlay parentRef={overlayRef} />
                </div>
            )}
            {/* TODO BEAM-1018 remove when real data available */}
            {/* <StorefrontInfoModal
                title={gettext("promotion.button.see_all")}
                isOpen={isPromoModalOpen}
                onClose={closePromoModal}
            >
                <PromotionInfo promotions={mockPromotions} />
            </StorefrontInfoModal> */}
            {/* TODO BEAM-1018 remove when real data available */}
            <View className={clsx(container, wrapper)}>
                {productArea && <ProductArea />}
                {productArea.product_purchase_type !== ProductPurchaseType.EXPRESS_CHECKOUT && (
                    <ProductPriceComparison />
                )}
                <RelatedArea productLayout={productLayout} />
                <Breadcrumbs productLayout={productLayout} />
            </View>
            {helpCentreURLs && (
                <Footer productLayout={productLayout} helpCentreURLs={helpCentreURLs} />
            )}
        </InStockProductPageContextProvider>
    );
}
